import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllMPSteelElevatedTempTables = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.MP_STEEL_ELEVATED_TEMP_TABLE}`, {
        params: { page, size, search: searchString },
    });

    return response.data;
};